import { DetailedHTMLProps, ImgHTMLAttributes, memo, Suspense, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useImage, useImageProps } from "react-image";
import { emptyImage } from "./utils";

export type SimpleImageProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & useImageProps;

const SimpleImageInner = memo<SimpleImageProps>(({ srcList, imgPromise, useSuspense, ...props }) => {

  const wrappedSrcList = useMemo(() => {
    let wrappedSrcList: string | string[] = emptyImage;
    if (Array.isArray(srcList)) {
      const filtered = srcList.filter(x => x);
      if (filtered.length) {
        wrappedSrcList = filtered;
      }
    } else if (srcList) {
      wrappedSrcList = srcList;
    }
    return wrappedSrcList;
  }, [ srcList ]);

  const { src } = useImage({
    srcList: wrappedSrcList,
    imgPromise,
    useSuspense,
  });

  return (
    <img src={src} alt="" {...props} />
  );
});


export const SimpleImage = memo<SimpleImageProps>(props => {
  return (
    <ErrorBoundary fallbackRender={() => <p />}>
      <Suspense fallback={null}>
        <SimpleImageInner {...props} />
      </Suspense>
    </ErrorBoundary>
  );
});


export default SimpleImage;
